import { AuthenticationType, AuthorizationStatus } from './types';
import { Subscriber } from './Subscriber';
import { authInterface, setState, versionInfo } from './authorizeImpl';

const globalObject: any = window as any;
globalObject.sas = globalObject.sas || {};
if (!globalObject.sas.__authInterface) {
  globalObject.sas.__authInterface = authInterface;
  authInterface.activate();
} else {
  const auth = globalObject.sas.__authInterface as typeof authInterface;
  const info = auth.versionInfo;
  let upgrade = false;
  if (info.major < versionInfo.major) {
    upgrade = true;
  } else if (info.major === versionInfo.major && info.minor < versionInfo.minor) {
    upgrade = true;
  } else if (
    info.major === versionInfo.major &&
    info.minor === versionInfo.minor &&
    info.patch < versionInfo.patch
  ) {
    upgrade = true;
  }
  if (upgrade) {
    setState(auth._getState());
    auth.deactivate();
    authInterface.activate();
    globalObject.sas.__authInterface = authInterface;
  }
}

function getInterface(): typeof authInterface {
  return globalObject.sas.__authInterface;
}

export function getAuthorizationInfo(server: string, authenticationType?: AuthenticationType) {
  const authInterface = getInterface();
  const key = authInterface.getKey(server, authenticationType) ?? server;
  return authInterface._getState().authMap.get(key);
}

const subscriberMap = new Map<string, Subscriber<AuthorizationStatus>>();

export function getConnection(server: string, authenticationType: AuthenticationType) {
  const key = getInterface().getKey(server, authenticationType) ?? server;
  const sub = subscriberMap.get(key);
  if (sub) {
    return sub;
  }
  const info = getInterface().addConnection(server, authenticationType);
  const newSub = new Subscriber(info);
  subscriberMap.set(key, newSub);
  getInterface().onStatusChange(
    server,
    (status) => {
      newSub.next(status);
    },
    authenticationType
  );
  return newSub;
}

export function getServerStatus(server: string, authenticationType?: AuthenticationType) {
  return getAuthorizationInfo(server, authenticationType)?.status;
}

export function authorize(server: string, authenticationType?: AuthenticationType) {
  getInterface().authorize(server, authenticationType);
}

export function deauthorize(server: string, authenticationType?: AuthenticationType) {
  getInterface().deauthorize(server, authenticationType);
}

export function _serverHackOrAuthorized(server: string, authenticationType?: AuthenticationType) {
  const info = getAuthorizationInfo(server, authenticationType);
  return info?.serverHack || info?.status === 'authorized';
}

// for testing
export function _reset() {
  getInterface().deactivate();
  authInterface.activate();
  subscriberMap.clear();
}
